var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{attrs:{"id":"loading-center"}},[_c('div',{attrs:{"id":"loading-center-absolute"}},[_c('div',{staticClass:"object",attrs:{"id":"object_one"}}),_vm._v(" "),_c('div',{staticClass:"object",attrs:{"id":"object_two"}}),_vm._v(" "),_c('div',{staticClass:"object",attrs:{"id":"object_three"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d8ccce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheLoading.vue
// module id = null
// module chunks = 